import { DatePicker, Tooltip, TimePicker, message } from "antd";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import EmojiPicker from 'emoji-picker-react';
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import TaskServices from "../../../Services/TaskServices";
import ProjectServices from "../../../Services/ProjectServices";
import DataParser from "../../../utlits/Dataparser";
import secureLocalStorage from "react-secure-storage";
import UserServices from "../../../Services/UserService";
import SocketService from "../../../Services/SocketService";
import Select from "react-select";
import SprintServices from "../../../Services/SprintServices";

const CreateTask = (props) => {
  const {
    priority,
    reFreshData,
    id,
    labelledby,
    parentId,
    parentDueDate,
    closeBtnId,
    initialProjectId,
    initialProjectName,
    projects: propProjects,
  } = props;

  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [users, setUsers] = useState([]);
  const [description, setDescription] = useState("");
  const [isDescFocused, setIsDescFocused] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const quillRef = React.useRef(null);
  const clickedLinkRef = React.useRef({ index: null, length: null });
  const [assignedTo, setAssignedTo] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [periority, setPeriority] = useState("");
  const [periorityError, setPeriorityError] = useState(false);
  const [approval, setApproval] = useState("");
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [showAllAttachments, setShowAllAttachments] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [recurringPeriod, setRecurringPeriod] = useState("");
  const [recurringTime, setRecurringTime] = useState("09:00");
  const [recurringTotalCount, setRecurringTotalCount] = useState(0);
  const [recurringExcludeDays, setRecurringExcludeDays] = useState([]);
  const selectRef = useRef(null);
  const descBlurTimeoutRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [sprints, setSprints] = useState([]);
  const [sprintId, setSprintId] = useState(null);
  const [isSprintsLoading, setIsSprintsLoading] = useState(false);

  const companyId = DataParser.CompanyId();
  const companyIdentifier = DataParser.CompanyIdentifier();

  const [userSearchTerm, setUserSearchTerm] = useState("");

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isPriorityMenuOpen, setIsPriorityMenuOpen] = useState(false);
  const [isApprovalMenuOpen, setIsApprovalMenuOpen] = useState(false);
  const [isStatusMenuOpen, setIsStatusMenuOpen] = useState(false);
  const [isRecurringMenuOpen, setIsRecurringMenuOpen] = useState(false);
  const [isRecurrencePeriodMenuOpen, setIsRecurrencePeriodMenuOpen] = useState(false);

  const filteredUserOptions = users
    .map(user => ({ value: user.id, label: user.full_name }))
    .filter(option => option.label.toLowerCase().includes(userSearchTerm.toLowerCase()))
    .slice(0, 4);

  const actionSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      background: "transparent",
      boxShadow: "none",
      minHeight: "34px",
      fontSize: "13px",
      cursor: "pointer",
      width: "auto",
      minWidth: "80px",
      "&:hover": { border: "none" },
    }),
    valueContainer: (provided) => ({ ...provided, padding: "0 2px" }),
    singleValue: (provided) => ({ ...provided, color: "#1D1D1D", fontWeight: "600" }),
    placeholder: (provided) => ({ ...provided, color: "#a0a0a0", fontWeight: "500" }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
      zIndex: 9999,
      border: "1px solid #E8E8E8",
      padding: "5px",
      width: "250px"
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isFocused ? "#F5F5F5" : "transparent",
      color: "#1a1a1a",
      borderRadius: "6px",
      margin: "2px 0",
      cursor: "pointer",
      "&:active": { backgroundColor: "#F5F5F5" },
    }),
    input: (provided) => ({ ...provided, color: "#1D1D1D" }),
  };

  useEffect(() => {
    const userId = DataParser.UserId();
    const datee = DataParser.getDateinFormat();

    setDueDate(datee);
    setStatus("Pending");
    setApproval(0);
    setAssignedTo(userId);
    setPeriority("");
    setTitle("");
    setDescription("");
    setAttachments([]);
    setIsRecurring(false);
    setRecurringPeriod("");

    const fetchUsers = () => {
      UserServices.getDepartmentUsernames(companyId)
        .then((res) => {
          if (res.Good) {
            setUsers(res.data.user);
          }
        })
        .catch((err) => console.error("Error fetching users:", err));
    };

    const fetchProjects = () => {
      ProjectServices.getAllProjects(companyId)
        .then((res) => {
          if (res.Good) {
            setProjects(res.data.projects || []);
          }
        })
        .catch((err) => console.error("Error fetching projects:", err));
    };

    fetchUsers();
    if (!propProjects || propProjects.length === 0) {
      fetchProjects();
    }

    SocketService.connect();
    const handleUserUpdate = (payload) => {
      if (String(payload.company_id) !== String(companyId)) return;
      fetchUsers();
    };

    SocketService.on("user_update", handleUserUpdate);

    const handleClickOutside = (event) => {
      // User menu
      if (!event.target.closest('.user-select-container')) {
        setIsUserMenuOpen(false);
        setUserSearchTerm("");
      }
      // Priority menu
      if (!event.target.closest('.priority-select-container')) {
        setIsPriorityMenuOpen(false);
      }
      // Approval menu
      if (!event.target.closest('.approval-select-container')) {
        setIsApprovalMenuOpen(false);
      }
      // Status menu
      if (!event.target.closest('.status-select-container')) {
        setIsStatusMenuOpen(false);
      }
      // Recurring menu
      if (!event.target.closest('.recurring-select-container')) {
        setIsRecurringMenuOpen(false);
      }
      // Recurrence Period menu
      if (!event.target.closest('.recurrence-period-select-container')) {
        setIsRecurrencePeriodMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      SocketService.off("user_update", handleUserUpdate);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [companyId, propProjects]);

  useEffect(() => {
    if (propProjects && propProjects.length > 0) {
      setProjects(propProjects);
    }
  }, [propProjects]);

  useEffect(() => {
    if (projectId && projectId.value) {
      setIsSprintsLoading(true);
      SprintServices.getSprints(companyId, projectId.value)
        .then(res => {
          if (res.Good) {
            setSprints(res.data || []);
          }
        })
        .finally(() => setIsSprintsLoading(false));
    } else {
      setSprints([]);
      setSprintId(null);
    }
  }, [projectId, companyId]);

  const addAttachment = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAttachments((prev) => [...prev, file]);
    e.target.value = null;
  };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const previewAttachment = (file) => {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const resetForm = () => {
    const userId = DataParser.UserId();
    const datee = DataParser.getDateinFormat();
    setTitle("");
    setAssignedTo(userId);
    setDueDate(datee);
    setPeriority("");
    setApproval(0);
    setStatus("Pending");
    setDescription("");
    setAttachments([]);
    setIsRecurring(false);
    setRecurringPeriod("");
    setRecurringTime("09:00");
    setRecurringTotalCount(0);
    setPeriorityError(false);
    setStatusError(false);
    if (initialProjectId) {
      const foundProject = projects.find(p => String(p.id || p._id) === String(initialProjectId));
      if (foundProject) {
        setProjectId({ value: foundProject.id || foundProject._id, label: foundProject.name });
      } else {
        setProjectId({ value: initialProjectId, label: initialProjectName || "Loading Project..." });
      }
    } else {
      setProjectId(null);
    }
    setSprintId(null);
    setIsSubmitting(false);
  };

  useEffect(() => {
    const modalEl = document.getElementById(id);
    const handleHide = () => resetForm();
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleHide);
    }
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleHide);
      }
    };
  }, [id]);

  useEffect(() => {
    if (initialProjectId) {
      const foundProject = projects.find(p => String(p.id || p._id) === String(initialProjectId));
      if (foundProject) {
        setProjectId({ value: foundProject.id || foundProject._id, label: foundProject.name });
      } else {
        setProjectId({ value: initialProjectId, label: initialProjectName || "Loading Project..." });
      }
    }
  }, [initialProjectId, initialProjectName, projects]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const missing = [];
    if (!title?.trim()) missing.push("Title");
    if (!assignedTo) missing.push("Assigned To");
    if (!periority) missing.push("Priority");
    if (status === "") missing.push("Status");

    setPeriorityError(!periority);
    setStatusError(status === "");

    if (missing.length > 0) {
      message.error(`Please fill in required fields: ${missing.join(", ")}`);
      return;
    }

    const selectedProject = projects.find(p => String(p.id || p._id) === String(projectId?.value));
    const selectedSprint = sprints.find(s => String(s.id) === String(sprintId?.value));

    if (selectedSprint && moment(dueDate).isAfter(moment(selectedSprint.due_date), 'day')) {
      message.error(`Task due date cannot be later than sprint due date (${moment(selectedSprint.due_date).format("MMM D, YYYY")})`);
      return;
    }

    if (!selectedSprint && selectedProject && selectedProject.due_date && moment(dueDate).isAfter(moment(selectedProject.due_date), 'day')) {
      message.error(`Task due date cannot be later than project due date (${moment(selectedProject.due_date).format("MMM D, YYYY")})`);
      return;
    }

    if (parentId && parentDueDate && dueDate && moment(dueDate).isAfter(moment(parentDueDate), 'day')) {
      message.error(`Subtask due date cannot exceed parent task due date (${moment(parentDueDate).format("MMM D, YYYY")})`);
      return;
    }

    setIsSubmitting(true);

    const body = {
      company_id: companyId,
      company_identifier: companyIdentifier,
      title,
      assign_to: assignedTo,
      due_date: moment(dueDate).format("YYYY-MM-DD"),
      priority: periority,
      approval_required: approval,
      status,
      description,
      is_recurring: isRecurring,
      recurring_period: recurringPeriod,
      recurring_time: recurringTime,
      recurringTotalCount,
      recurring_exclude_days: recurringExcludeDays,
      project_id: projectId ? projectId.value : (props.projectId || 0),
      sprint_id: sprintId ? sprintId.value : null,
      parent_id: parentId || 0,
    };

    try {
      let res;
      if (parentId && parentId !== 0) {
        res = await TaskServices.createSubTask(parentId, body);
      } else {
        res = await TaskServices.createTask(body);
      }

      if (res.Good) {
        const newTaskId = res.data?.id || res.inserted_id || res.task_id;
        const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
        const checkAuth = adminInfo ? adminInfo.authToken : "";

        const uploadPromises = attachments.map((file) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("company_id", companyId);
          formData.append("company_identifier", companyIdentifier);

          return axios.post(
            `${process.env.REACT_APP_BASE_URL}tasks/attachments/${newTaskId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                authToken: checkAuth,
              },
            }
          ).catch(() => message.error(`Failed to upload "${file.name}"`));
        });

        await Promise.all(uploadPromises);
        message.success("Task created successfully!");

        const closeBtn = document.getElementById(closeBtnId || "taskClose");
        if (closeBtn) closeBtn.click();

        if (reFreshData) reFreshData(e);
      } else {
        message.error(res.data || "Failed to create task.");
      }
    } catch (err) {
      console.error("Task creation failed:", err);
      const errorMsg = err.response?.data?.data || err.response?.data?.message || "Failed to create task.";
      message.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return ReactDOM.createPortal(
    <div
      className="modal fade"
      id={id}
      tabIndex={-1}
      aria-labelledby={labelledby}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "850px" }}>
        <div className="modal-content" style={{ borderRadius: "24px", border: "none", padding: "10px 18px 20px 18px", boxShadow: "0 10px 40px rgba(0,0,0,0.12)" }}>
          <div className="modal-header border-0 pb-2 d-flex justify-content-end" style={{ paddingBottom: '8px' }}>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id={closeBtnId || "taskClose"}
              onClick={() => resetForm()}
              style={{ fontSize: '18px', backgroundSize: '16px', opacity: 0.8 }}
            />
          </div>
          <div className="modal-body pt-0 px-4 pb-1">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* ── Title Section ────────────────────────────────── */}
                <div className="col-12 mb-2">
                  <div className="float-input-wrap task-title-float-wrap">
                    <input
                      type="text"
                      id="taskTitleInput"
                      className=""
                      placeholder="Enter a task title"
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                      autoFocus
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        height: "44px",
                        padding: "18px 16px 8px 16px"
                      }}
                    />
                    <label htmlFor="taskTitleInput">Enter a task title</label>
                  </div>
                </div>

                {/* ── Description Section ──────────────────────────────── */}
                <div className="col-12 mb-3">
                  <div
                    className={`float-input-wrap task-desc-float-wrap ${isDescFocused || showLinkInput || showEmojiPicker ? 'focused' : ''} ${(description && description !== '<p><br></p>') ? 'has-value' : ''}`}
                    onClick={(e) => {
                      const anchor = e.target.closest('a');
                      if (anchor && anchor.closest('.ql-editor')) {
                        e.preventDefault();
                        const url = anchor.getAttribute('href');
                        setLinkUrl(url);
                        setShowLinkInput(true);

                        const q = quillRef.current.getEditor();
                        const Quill = ReactQuill.Quill;
                        const blot = Quill.find(anchor);
                        if (blot) {
                          clickedLinkRef.current = {
                            index: q.getIndex(blot),
                            length: blot.length()
                          };
                        }
                      }
                    }}
                  >
                    <ReactQuill
                      ref={quillRef}
                      theme="snow"
                      placeholder=""
                      value={description}
                      onChange={setDescription}
                      onFocus={() => {
                        if (descBlurTimeoutRef.current) {
                          clearTimeout(descBlurTimeoutRef.current);
                          descBlurTimeoutRef.current = null;
                        }
                        setIsDescFocused(true);
                      }}
                      onBlur={() => {
                        descBlurTimeoutRef.current = setTimeout(() => {
                          setIsDescFocused(false);
                        }, 150);
                      }}
                      modules={{
                        toolbar: false
                      }}
                      style={{
                        fontSize: "15px",
                      }}
                    />
                    <span className="desc-icon" style={{ display:'inline-block', width:'18px', height:'18px', flexShrink:0, backgroundColor: '#a0a0a0', mask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain" }} />
                    <label>Description</label>

                    {/* ── Custom Toolbar ──────────────────────────────── */}
                    <div className="desc-toolbar" onMouseDown={(e) => e.preventDefault()}>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('bold', !format.bold);
                      }}>
                        <i className="uil uil-bold" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('italic', !format.italic);
                      }}>
                        <i className="uil uil-italic" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('underline', !format.underline);
                      }}>
                        <i className="uil uil-underline" />
                      </button>
                      <div className="position-relative">
                        <button type="button" className="toolbar-btn" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                          <i className="uil uil-smile" />
                        </button>
                        {showEmojiPicker && (
                          <div className="position-absolute" style={{ top: '40px', left: '0', zIndex: 10000 }} onMouseDown={(e) => e.stopPropagation()}>
                            <EmojiPicker
                              onEmojiClick={(emojiData) => {
                                const quill = quillRef.current.getEditor();
                                const range = quill.getSelection();
                                if (range) {
                                  if (range.length > 0) {
                                    quill.deleteText(range.index, range.length);
                                  }
                                  quill.insertText(range.index, emojiData.emoji);
                                  quill.setSelection(range.index + emojiData.emoji.length);
                                } else {
                                  quill.insertText(quill.getLength(), emojiData.emoji);
                                }
                                setShowEmojiPicker(false);
                              }}
                              width={300}
                              height={400}
                            />
                          </div>
                        )}
                      </div>
                      <div className="position-relative">
                        <button type="button" className="toolbar-btn" onClick={() => {
                          const quill = quillRef.current.getEditor();
                          const format = quill.getFormat();
                          if (format.link) {
                            setLinkUrl(format.link);
                            const range = quill.getSelection();
                            if (range) {
                              const [leaf] = quill.getLeaf(range.index);
                              let blot = leaf;
                              const Quill = ReactQuill.Quill;
                              while (blot && blot.statics.blotName !== 'link' && blot !== quill.scroll) {
                                blot = blot.parent;
                              }
                              if (blot && blot.statics.blotName === 'link') {
                                clickedLinkRef.current = {
                                  index: quill.getIndex(blot),
                                  length: blot.length()
                                };
                              } else {
                                clickedLinkRef.current = { index: null, length: null };
                              }
                            }
                          } else {
                            setLinkUrl("");
                            clickedLinkRef.current = { index: null, length: null };
                          }
                          setShowLinkInput(!showLinkInput);
                        }}>
                          <i className="uil uil-link" />
                        </button>
                        {showLinkInput && (
                          <div className="position-absolute link-popover" onMouseDown={(e) => e.stopPropagation()}>
                            <div className="d-flex gap-2 align-items-center">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Paste or type a link..."
                                value={linkUrl}
                                onChange={(e) => setLinkUrl(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    const quill = quillRef.current.getEditor();
                                    const { index, length } = clickedLinkRef.current;
                                    if (index !== null && length !== null) {
                                      quill.formatText(index, length, 'link', linkUrl);
                                    } else {
                                      quill.format('link', linkUrl);
                                    }
                                    setShowLinkInput(false);
                                    setLinkUrl("");
                                    clickedLinkRef.current = { index: null, length: null };
                                  }
                                }}
                              />
                              {linkUrl && (
                                <a
                                  href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="toolbar-btn d-flex align-items-center justify-content-center"
                                  style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #1D1D1D', color: '#1D1D1D', textDecoration: 'none', background: '#fff' }}
                                  title="Open link in new tab"
                                >
                                  <i className="uil uil-external-link-alt" style={{ fontSize: '18px' }} />
                                </a>
                              )}
                              {linkUrl && (
                                <button
                                  type="button"
                                  className="toolbar-btn d-flex align-items-center justify-content-center"
                                  style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #ff4d4f', color: '#ff4d4f', background: '#fff' }}
                                  title="Remove link"
                                  onClick={() => {
                                    const quill = quillRef.current.getEditor();
                                    const { index, length } = clickedLinkRef.current;
                                    if (index !== null && length !== null) {
                                      quill.formatText(index, length, 'link', false);
                                    } else {
                                      quill.format('link', false);
                                    }
                                    setShowLinkInput(false);
                                    setLinkUrl("");
                                    clickedLinkRef.current = { index: null, length: null };
                                  }}
                                >
                                  <i className="uil uil-link-broken" style={{ fontSize: '18px' }} />
                                </button>
                              )}
                              <button
                                type="button"
                                className="link-apply-btn"
                                onClick={() => {
                                  const quill = quillRef.current.getEditor();
                                  const { index, length } = clickedLinkRef.current;
                                  if (index !== null && length !== null) {
                                    quill.formatText(index, length, 'link', linkUrl);
                                  } else {
                                    quill.format('link', linkUrl);
                                  }
                                  setShowLinkInput(false);
                                  setLinkUrl("");
                                  clickedLinkRef.current = { index: null, length: null };
                                }}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('list', format.list === 'bullet' ? false : 'bullet');
                      }}>
                        <i className="uil uil-list-ul" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* ── Action Grid (Horizontal Bar) ─────────────────────── */}
                <div className="col-12 mb-4">
                  <div className="d-flex flex-wrap gap-1 align-items-center">
                    <div className="user-select-container position-relative">
                      <Tooltip title="Assigned To" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                          style={{ borderColor: isUserMenuOpen ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: assignedTo ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: assignedTo ? '#1D1D1D' : '#A0A0A0' }}>
                            {users.find(u => String(u.id) === String(assignedTo))?.full_name || "Assigned to"}
                          </span>
                        </div>
                      </Tooltip>

                      {isUserMenuOpen && (
                        <div className="custom-user-dropdown">
                          {/* Search Bar */}
                          <div className="search-header">
                            <i className="uil uil-search" />
                            <input
                              autoFocus
                              placeholder="Search or enter email..."
                              value={userSearchTerm}
                              onChange={(e) => setUserSearchTerm(e.target.value)}
                            />
                          </div>

                          {/* User List */}
                          <div className="user-list-scroll">
                            {filteredUserOptions.length > 0 ? (
                              filteredUserOptions.map(option => {
                                const initials = option.label.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
                                return (
                                  <div
                                    key={option.value}
                                    className="user-option-item"
                                    onClick={() => {
                                      setAssignedTo(option.value);
                                      setIsUserMenuOpen(false);
                                      setUserSearchTerm("");
                                    }}
                                  >
                                    <div className="user-avatar-mini">{initials}</div>
                                    <span>{option.label}</span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="no-users-found">No members found</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Due Date */}
                    <Tooltip title="Due Date" placement="top">
                      <div className="action-btn-wrap">
                        <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: dueDate ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain" }} />
                        <DatePicker
                          value={dueDate ? moment(dueDate) : null}
                          onChange={(date) => setDueDate(date)}
                          format="DD MMM"
                          placeholder="Due Date"
                          className="action-datepicker"
                          bordered={false}
                          allowClear={false}
                          suffixIcon={null}
                          disabledDate={(current) => {
                            if (current && current < moment().startOf('day')) return true;
                            if (parentDueDate && current && current.isAfter(moment(parentDueDate).endOf('day'))) return true;
                            return false;
                          }}
                        />
                      </div>
                    </Tooltip>

                    {/* Priority (Custom modern dropdown) */}
                    <div className="priority-select-container position-relative">
                      <Tooltip title="Priority" placement="top">
                        <div
                          className={`action-btn-wrap cursor-pointer ${periorityError ? 'is-invalid' : ''}`}
                          onClick={() => setIsPriorityMenuOpen(!isPriorityMenuOpen)}
                          style={{ borderColor: isPriorityMenuOpen ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: periority ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/prioritymodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/prioritymodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: periority ? '#1D1D1D' : '#A0A0A0' }}>
                            {priority?.find(p => String(p.id) === String(periority))?.name || "Priority"}
                          </span>

                        </div>
                      </Tooltip>

                      {isPriorityMenuOpen && (
                        <div className="custom-priority-dropdown">
                          <div className="priority-list-scroll">
                            {priority && priority.map(el => (
                              <div
                                key={el.id}
                                className="priority-option-item"
                                onClick={() => {
                                  setPeriority(el.id);
                                  setPeriorityError("");
                                  setIsPriorityMenuOpen(false);
                                }}
                              >
                                <span style={{ backgroundColor: el.color, width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                                <span>{el.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Approval Required (Custom modern dropdown) */}
                    <div className="approval-select-container position-relative">
                      <Tooltip title="Approval Required" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          onClick={() => setIsApprovalMenuOpen(!isApprovalMenuOpen)}
                          style={{ borderColor: isApprovalMenuOpen ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: (approval === 1 || approval === 0) ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: (approval === 1 || approval === 0) ? '#1D1D1D' : '#A0A0A0' }}>
                            {approval === 1 ? "Yes" : approval === 0 ? "No" : "Approval Required"}
                          </span>

                        </div>
                      </Tooltip>

                      {isApprovalMenuOpen && (
                        <div className="custom-priority-dropdown" style={{ width: '160px' }}>
                          <div className="priority-list-scroll">
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setApproval(1);
                                setIsApprovalMenuOpen(false);
                              }}
                            >
                              <span>Yes</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setApproval(0);
                                setIsApprovalMenuOpen(false);
                              }}
                            >
                              <span>No</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Status (Custom modern dropdown) */}
                    <div className="status-select-container position-relative">
                      <Tooltip title="Task Status" placement="top">
                        <div
                          className={`action-btn-wrap cursor-pointer ${statusError ? 'is-invalid' : ''}`}
                          onClick={() => setIsStatusMenuOpen(!isStatusMenuOpen)}
                          style={{ borderColor: isStatusMenuOpen ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: status ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: status ? '#1D1D1D' : '#A0A0A0' }}>
                            {status === "Pending" ? "Pending" : status === "In-Progress" ? "In Progress" : status === "On-Hold" ? "On Hold" : status === "Complete" ? "Complete" : "Task Status"}
                          </span>

                        </div>
                      </Tooltip>

                      {isStatusMenuOpen && (
                        <div className="custom-priority-dropdown" style={{ width: '160px' }}>
                          <div className="priority-list-scroll">
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("Pending");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#DFA70D', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>Pending</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("In-Progress");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#607EF9', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>In Progress</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("On-Hold");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#0DDFAB', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>On Hold</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("Complete");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#1CB333', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>Complete</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Recurring (Custom modern dropdown) */}
                    <div className="recurring-select-container position-relative">
                      <Tooltip title="Recurring Task" placement="top">
                        <div
                          className={`action-btn-wrap cursor-pointer ${isRecurring ? 'active-pill' : ''}`}
                          onClick={() => setIsRecurringMenuOpen(!isRecurringMenuOpen)}
                          style={{ borderColor: isRecurringMenuOpen ? '#1D1D1D' : (isRecurring ? '#0DDFAB' : '#E8E8E8') }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: isRecurring ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: isRecurring ? '#1D1D1D' : '#A0A0A0' }}>Recurring Task</span>

                        </div>
                      </Tooltip>

                      {isRecurringMenuOpen && (
                        <div className="custom-recurring-dropdown">
                          <div className="recurring-menu-content">
                            {/* Enable Toggle */}
                            <div className="d-flex align-items-center justify-content-between mb-1 pb-1 border-bottom">
                              <span style={{ fontSize: '14px', fontWeight: '600', color: '#1D1D1D' }}>Enable Recurring</span>
                              <div className="form-check form-switch m-0">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  checked={isRecurring}
                                  onChange={(e) => setIsRecurring(e.target.checked)}
                                />
                              </div>
                            </div>

                            {isRecurring && (
                              <>
                                {/* Period (Custom modern dropdown inside Recurring menu) */}
                                <div className="recurring-section">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">Recurrence Period</span>
                                  </div>
                                  <div className="recurrence-period-select-container position-relative">
                                    <div
                                      className="recurring-custom-select-trigger"
                                      onClick={() => setIsRecurrencePeriodMenuOpen(!isRecurrencePeriodMenuOpen)}
                                      style={{ color: recurringPeriod ? '#1D1D1D' : '#A0A0A0' }}
                                    >
                                      <span>{recurringPeriod ? recurringPeriod.charAt(0).toUpperCase() + recurringPeriod.slice(1) : "+ Add Period"}</span>
                                      <i className={`uil uil-angle-down`} style={{ transition: 'transform 0.2s', transform: isRecurrencePeriodMenuOpen ? 'rotate(180deg)' : 'none' }} />
                                    </div>

                                    {isRecurrencePeriodMenuOpen && (
                                      <div className="custom-priority-dropdown" style={{ width: '100%', left: '0', top: '100%' }}>
                                        <div className="priority-list-scroll">
                                          {["daily", "weekly", "monthly", "annually"].map(p => (
                                            <div
                                              key={p}
                                              className="priority-option-item"
                                              onClick={() => {
                                                setRecurringPeriod(p);
                                                setIsRecurrencePeriodMenuOpen(false);
                                              }}
                                            >
                                              <span>{p.charAt(0).toUpperCase() + p.slice(1)}</span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Exclude Days — only shown when Daily is selected */}
                                {recurringPeriod === "daily" && (
                                  <div className="recurring-section">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <i className="uil uil-ban section-icon" />
                                      <span className="section-label">Exclude Days</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                      {[
                                        { key: "monday", label: "Mon" },
                                        { key: "tuesday", label: "Tue" },
                                        { key: "wednesday", label: "Wed" },
                                        { key: "thursday", label: "Thu" },
                                        { key: "friday", label: "Fri" },
                                        { key: "saturday", label: "Sat" },
                                        { key: "sunday", label: "Sun" },
                                      ].map(({ key, label }) => {
                                        const isExcluded = recurringExcludeDays.includes(key);
                                        return (
                                          <button
                                            key={key}
                                            type="button"
                                            onClick={() => setRecurringExcludeDays(prev =>
                                              isExcluded ? prev.filter(d => d !== key) : [...prev, key]
                                            )}
                                            style={{
                                              padding: '3px 7px',
                                              borderRadius: '6px',
                                              border: `1px solid ${isExcluded ? '#1D1D1D' : '#E8E8E8'}`,
                                              background: isExcluded ? '#1D1D1D' : '#fff',
                                              color: isExcluded ? '#fff' : '#A0A0A0',
                                              fontSize: '11px',
                                              fontWeight: '600',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {label}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}

                                {/* Time */}
                                <div className="recurring-section">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">Run Time</span>
                                  </div>
                                  <TimePicker
                                    value={recurringTime ? moment(recurringTime, 'HH:mm') : null}
                                    onChange={(time, timeString) => setRecurringTime(timeString)}
                                    format="HH:mm"
                                    bordered={false}
                                    placeholder="+ Add Time"
                                    className="recurring-inline-timepicker"
                                    suffixIcon={null}
                                    allowClear={false}
                                    style={{ color: recurringTime ? '#1D1D1D' : '#A0A0A0' }}
                                  />
                                </div>

                                {/* No. of Recurrences */}
                                <div className="recurring-section border-0 pb-0">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">No. of Recurrences</span>
                                  </div>
                                  <input
                                    type="number"
                                    className="recurring-inline-input"
                                    placeholder="+ Add No"
                                    value={recurringTotalCount || ""}
                                    onChange={(e) => setRecurringTotalCount(parseInt(e.target.value) || 0)}
                                    style={{ color: recurringTotalCount ? '#1D1D1D' : '#A0A0A0' }}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Subtask Placeholder (Commented) */}
                    {/* <div className="action-btn-wrap disabled opacity-50">
                       <i className="uil uil-sitemap action-icon" />
                       <span style={{ fontSize: '13px', fontWeight: '500', color: '#666' }}>Add Subtask</span>
                     </div> */}

                    {/* Dependencies Placeholder (Commented) */}
                    {/* <div className="action-btn-wrap disabled opacity-50">
                       <i className="uil uil-link-h action-icon" />
                       <span style={{ fontSize: '13px', fontWeight: '500', color: '#666' }}>Dependencies</span>
                     </div> */}
                  </div>
                </div>

                {/* ── Footer Actions ───────────────────────────────────── */}
                <div className="col-12 d-flex align-items-center justify-content-between mt-2 pt-2 border-top">
                  <div className="d-flex align-items-center gap-3">
                    <Tooltip title="Attach Files" placement="top">
                      <label htmlFor="task-attachment" style={{ cursor: 'pointer', margin: 0 }}>
                        <div className="attachment-trigger">
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: '#1a1a1a', mask:"url('/assets/images/attachmentmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/attachmentmodal.svg') no-repeat center / contain" }} />
                        </div>
                      </label>
                    </Tooltip>
                    <input
                      type="file"
                      id="task-attachment"
                      style={{ display: 'none' }}
                      onChange={addAttachment}
                    />
                    {attachments.length > 0 && (
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        {(showAllAttachments ? attachments : attachments.slice(0, 3)).map((file, index) => (
                          <div
                            key={index}
                            className="attachment-preview-chip cursor-pointer"
                            onClick={() => previewAttachment(file)}
                          >
                            <i className="uil uil-import chip-download-icon" />
                            <span className="chip-file-name">
                              {file.name.length > 20 ? file.name.substring(0, 15) + '...' + file.name.split('.').pop() : file.name}
                            </span>
                            <i
                              className="uil uil-times chip-remove-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeAttachment(index);
                              }}
                            />
                          </div>
                        ))}
                        {attachments.length > 3 && (
                          <div
                            className="attachment-preview-chip cursor-pointer"
                            onClick={() => setShowAllAttachments(!showAllAttachments)}
                            style={{ background: '#f8f9fa', border: '1px dashed #adb5bd', color: '#1D1D1D' }}
                          >
                            <span style={{ fontWeight: 600 }}>
                              {showAllAttachments ? "Show Less" : `+ ${attachments.length - 3} more`}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn-create-task"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div className="spinner-border spinner-border-sm me-2" role="status" />
                    ) : (
                      <i className="uil uil-plus me-1" style={{ fontSize: '16px' }} />
                    )}
                    Create Task
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>{`
        .task-title-float-wrap input {
          border-radius: 12px !important;
          height: 44px !important;
          padding: 0 16px !important;
          font-size: 17px !important;
          font-weight: 500 !important;
          border: 1.5px solid transparent !important;
          transition: all 0.2s ease !important;
        }
        .task-title-float-wrap input::placeholder {
          color: #a0a0a0 !important;
          font-size: 17px !important;
          font-weight: 500 !important;
        }
        .task-title-float-wrap input:hover, .task-title-float-wrap input:focus { border-color: #1D1D1D !important; }
        .task-title-float-wrap label {
          left: 16px !important;
          top: 50% !important;
          font-size: 17px !important;
          opacity: 0 !important; 
          transition: all 0.2s ease !important;
          pointer-events: none;
          background: #fff !important;
          z-index: 99 !important;
          padding: 0 5px;
        }
        /* Show label ONLY when focused */
        .task-title-float-wrap input:focus ~ label {
          top: 0 !important;
          font-size: 12px !important;
          opacity: 1 !important;
          background: #fff !important;
          z-index: 99 !important;
        }
        .task-title-float-wrap input:focus::placeholder {
          color: transparent !important;
        }

        .task-desc-float-wrap {
          position: relative;
          border-radius: 12px;
          border: 1.5px solid transparent;
          transition: all 0.2s ease;
        }
        .task-desc-float-wrap:hover, .task-desc-float-wrap.focused { border-color: #1D1D1D !important; }

        /* Popover Styling */
        .link-popover {
          background: #fff;
          border: 1.5px solid #1D1D1D;
          border-radius: 10px;
          padding: 4px;
          bottom: 50px !important;
          left: 10px !important;
          width: 320px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .link-popover input {
          border: none !important;
          box-shadow: none !important;
          font-size: 14px !important;
          padding: 8px 12px !important;
        }
        .action-datepicker {
          width: 52px !important;
          padding: 0 !important;
          margin-left: -8px !important;
        }
        .action-datepicker input {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #000 !important;
          padding-left: 0 !important;
          margin-left: 0 !important;
          cursor: pointer !important;
        }
        .link-apply-btn {
          background-color: #0DDFAB !important;
          border: none !important;
          color: #000 !important;
          font-weight: 600 !important;
          border-radius: 8px !important;
          padding: 6px 16px !important;
          font-size: 13px !important;
        }

        /* Quill Specific Styles */
        .quill {
          width: 100%;
        }
        .ql-container.ql-snow {
          border: none !important;
          font-family: inherit !important;
        }
        .ql-editor {
          padding: 12px 16px 8px 48px !important;
          min-height: 44px !important;
          max-height: 200px !important;
          overflow-y: auto !important;
          font-size: 15px !important;
          transition: all 0.2s ease;
        }
        .task-desc-float-wrap.focused .ql-editor,
        .task-desc-float-wrap.has-value .ql-editor,
        .task-desc-float-wrap .ql-editor:not(.ql-blank) {
          padding-left: 16px !important;
        }
        .ql-editor.ql-blank::before {
          display: none !important;
        }

        .task-desc-float-wrap .desc-icon {
          position: absolute;
          left: 16px;
          top: 13px !important;
          transform: none !important;
          color: #a0a0a0;
          transition: all 0.2s ease;
          pointer-events: none;
          z-index: 10;
          opacity: 1;
        }
        .task-desc-float-wrap.focused .desc-icon,
        .task-desc-float-wrap.has-value .desc-icon {
          opacity: 0 !important;
        }

        .task-desc-float-wrap label {
          position: absolute;
          left: 48px;
          top: 12px !important;
          transform: none !important;
          font-size: 17px !important;
          line-height: 20px !important;
          color: #a0a0a0;
          transition: all 0.2s ease !important;
          pointer-events: none;
          background: #fff !important;
          padding: 0 5px;
          z-index: 99 !important;
          opacity: 1;
        }
        .task-desc-float-wrap.focused label,
        .task-desc-float-wrap.has-value label {
          top: 0 !important;
          transform: translateY(-50%) !important;
          left: 12px !important;
          font-size: 12px !important;
          color: #1D1D1D !important;
          opacity: 1 !important;
          background: #fff !important;
          z-index: 99 !important;
        }
        .task-desc-float-wrap.has-value:not(.focused) label {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        .desc-toolbar {
          display: flex;
          gap: 4px;
          background: #F5F5F5;
          padding: 2px 4px;
          border-radius: 6px;
          width: fit-content;
          margin: 0 0 6px 16px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.2s ease;
          border: none !important;
        }
        .task-desc-float-wrap.focused .desc-toolbar {
          opacity: 1;
          visibility: visible;
        }
        .toolbar-btn {
          background: transparent !important;
          border: none !important;
          padding: 0 !important;
          border-radius: 4px;
          color: #1D1D1D !important;
          font-size: 14px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.2s ease;
          cursor: pointer;
          width: 26px !important;
          height: 26px !important;
        }
        .toolbar-btn i {
          display: block !important;
          visibility: visible !important;
          color: #1D1D1D !important;
          font-size: 14px !important;
        }
        .toolbar-btn:hover {
          background: #E8E8E8 !important;
        }
        .ql-snow .ql-stroke {
          display: none !important; /* Hide default Quill strokes if any */
        }
        .ql-snow .ql-fill {
          display: none !important;
        }
        /* Active state for icons */
        .ql-snow.ql-toolbar button.ql-active i {
          color: #0DDFAB !important;
        }

        ::selection {
          background: #0DDFAB !important;
          color: #000000 !important;
        }

        .action-btn-wrap {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 4px 8px;
          border: 1px solid #E8E8E8;
          border-radius: 5px;
          background: #fff;
          transition: all 0.2s ease;
          min-width: fit-content;
          height: 30px;
        }
        .action-btn-wrap:hover, .action-btn-wrap:focus-within {
          border-color: #1D1D1D;
        }
        
        .action-icon {
          font-size: 16px;
          color: #1D1D1D;
          display: flex;
          align-items: center;
        }

        .action-select-plain {
          border: none !important;
          background: transparent !important;
          font-size: 11px;
          font-weight: 600;
          color: #1D1D1D;
          cursor: pointer;
          padding: 0;
          outline: none;
        }
        .action-select-plain option { font-weight: 400; }

        .action-datepicker {
          width: 55px !important;
          margin-left: -3px !important;
          padding: 0 !important;
        }
        .action-datepicker .ant-picker-input > input {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #000 !important;
          cursor: pointer !important;
          padding-left: 0 !important;
        }
        .action-datepicker .ant-picker-input > input::placeholder { color: #a0a0a0 !important; }

        .custom-user-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          width: 250px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          z-index: 10000;
          margin-top: 5px;
          overflow: hidden;
        }
        .search-header {
          padding: 12px 16px;
          border-bottom: 1px solid #F0F0F0;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .search-header i {
          font-size: 18px;
          color: #1a1a1a;
        }
        .search-header input {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          font-size: 14px;
          width: 100%;
          color: #1D1D1D;
          font-weight: 400;
        }
        .user-list-scroll {
          padding: 5px;
          max-height: 250px;
          overflow-y: auto;
        }
        .user-option-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 10px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 11px;
          color: #1a1a1a;
        }
        .user-option-item:hover {
          background: #F5F5F5;
        }
        .user-avatar-mini {
          width: 20px;
          height: 20px;
          background-color: #0DDFAB;
          color: #fff;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 9px;
          font-weight: 700;
        }
        .custom-priority-dropdown { z-index: 10001;
          position: absolute;
          top: 100%;
          left: 0;
          width: 150px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          z-index: 10000;
          margin-top: 5px;
          overflow: hidden;
        }
        .priority-list-scroll {
          padding: 5px;
        }
        .priority-option-item {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 11px;
          color: #1a1a1a;
          font-weight: 500;
        }
        .priority-option-item:hover {
          background: #F5F5F5;
        }

        .custom-recurring-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          width: 260px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
          z-index: 10000;
          margin-top: 5px;
        }
        .recurring-menu-content {
          padding: 12px;
        }
        .recurring-section {
          margin-bottom: 4px; padding-bottom: 2px;
          border-bottom: 1px solid #F5F5F5;
        }
        .section-icon {
          font-size: 16px;
          color: #1D1D1D;
        }
        .section-label {
          font-size: 13px;
          font-weight: 600;
          color: #1D1D1D;
        }
                .recurring-inline-input {
          width: calc(100% - 30px) !important;
          margin-left: 26px !important;
          height: 34px !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background: transparent !important;
          appearance: textfield;
        }
        .recurring-inline-input::-webkit-outer-spin-button,
        .recurring-inline-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .recurring-custom-select-trigger, .recurring-inline-select, 
        .recurring-inline-input,
        .recurring-inline-timepicker {
          width: 100%;
          border: none !important;
          outline: none !important;
          padding: 0 !important;
          font-size: 12px !important;
          background: transparent !important;
          cursor: pointer;
          font-weight: 500;
          margin-left: 26px;
          width: calc(100% - 26px);
        }
                .recurring-custom-select-trigger {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: calc(100% - 26px);
          margin-left: 26px;
          height: 34px;
          min-height: 34px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .recurring-custom-select-trigger:hover {
          color: #1D1D1D !important;
        }

        .recurring-inline-select:focus,
        .recurring-inline-input:focus {
          color: #1D1D1D !important;
        }
        .recurring-inline-select option {
          color: #1D1D1D;
        }
        .custom-switch:checked {
          background-color: #0DDFAB !important;
          border-color: #0DDFAB !important;
        }

        .active-pill {
          border-color: #1D1D1D !important;
          background: #fff !important;
        }
        .cursor-pointer {
          cursor: pointer;
        }


        .attachment-trigger {
          width: 30px;
          height: 30px;
          border-radius: 5px;
          background: #f8f9fa;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          border: 1px solid #E8E8E8;
        }
        .attachment-trigger:hover { background: #f0f1f2; border-color: #adb5bd; }

        .btn-create-task {
          background-color: #0DDFAB;
          border: none;
          border-radius: 5px;
          height: 30px;
          padding: 0 20px;
          color: #fff;
          font-weight: 700;
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          box-shadow: none !important;
          flex-shrink: 0 !important;
        }
        .btn-create-task:hover {
          background-color: #0bc698;
          transform: translateY(-2px);
        }
        .btn-create-task:active { transform: translateY(0); }
        .btn-create-task:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }
        .attachment-preview-chip {
          display: flex;
          align-items: center;
          gap: 6px;
          background: #1D1D1D;
          color: #0DDFAB;
          padding: 0 8px;
          height: 24px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          transition: all 0.2s ease;
        }
        .chip-download-icon {
          font-size: 12px;
          color: #0DDFAB;
        }
        .chip-file-name {
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .chip-remove-icon {
          font-size: 14px;
          color: #0DDFAB;
          transition: transform 0.2s;
        }
        .chip-remove-icon:hover {
          transform: scale(1.2);
          color: #fff;
        }

        .recurring-inline-input:focus, 
        .recurring-inline-input:active, 
        .recurring-inline-input:focus-visible,
        .recurring-inline-select:focus,
        .recurring-inline-timepicker:focus,
        .ant-picker-focused {
          outline: none !important;
          border: none !important;
          box-shadow: none !important;
        }
      `}</style>
    </div>,
    document.body
  );
};

export default CreateTask;
